import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
	height: fit-content;
	width: 810px;
	max-height: 400px;
	overflow: scroll;
`;

export const TitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const OrderedCell = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: relative;
`;

export const HoverInfo = styled.div`
	display: flex;
	align-items: center;
	position: absolute;
	top: -8px;
	right: -12px;

	:hover .lead-order-info-card {
		opacity: 1;
		visibility: visible;
		transform: translateY(4px);
	}
`;

export const InfoCard = styled.div`
	position: absolute;
	top: 16px;
	right: 0;
	width: 200px;
	padding: 10px 12px;
	background: #ffffff;
	border: 1px solid ${Colors.gray};
	border-radius: 8px;
	box-shadow: rgb(220, 220, 220, 0.8) 0px 7px 29px 0px;
	opacity: 0;
	visibility: hidden;
	transform: translateY(4px);
	transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
	z-index: 20;
	text-align: left;
`;

export const InfoRow = styled.p`
	margin: 0;
	font-size: 12px;
	line-height: 18px;
	color: ${Colors.darkBlue};

	&:not(:last-child) {
		margin-bottom: 4px;
	}
`;
